export default {
  props: {
    labelText: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: '请输入手機號碼'
    },
    phone: {
      type: String,
      required: true
    }
  },
  watch: {
    'phone': {
      handler(newValue, oldValue) {
        if (newValue != undefined && newValue != '') {
          if (newValue.indexOf("86") == 0) {
            this.tel = newValue.substring(2);
            this.areaCode = "86";
          }
          if (newValue.indexOf("852") == 0) {
            this.tel = newValue.substring(3);
            this.areaCode = "852";
          }
        }
      },
      deep: true,
      immediate: true
    },
    'tel': {
      handler(newValue, oldValue) {
        if (newValue != undefined || newValue != '') {
          let sphone = this.areaCode + this.tel;
          if (sphone != this.phone) {
            //debugger
            this.$emit('update:phone', sphone);
            //this.phone = sphone
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      areaCode: '852',
      options: [{
        text: '852',
        value: '852'
      }
      /*  { text: '86', value: '86' } */],

      tel: '',
      phoneRules: [{
        pattern: /^\d{8}$/,
        message: '請輸入8位手機號碼'
      }]
    };
  },
  methods: {
    onAreaCodeChange() {
      this.tel = '';
      if (this.areaCode == '852') {
        this.phoneRules = [{
          pattern: /^\d{8}$/,
          message: '請輸入8位手機號碼'
        }];
      } else {
        this.phoneRules = [{
          pattern: /^1\d{10}$/,
          message: '請輸入11位手機號碼'
        }];
      }
    },
    handleValidate() {
      this.$refs.phoneInput.validate().then(result => {
        if (result == undefined) {
          this.$emit('validate-result', true);
        } else {}
        this.$emit('validate-result', false);
        // 校验成功
      }).catch(err => {
        // 校验失败，可以通过 err 属性获取错误信息
        this.$emit('validate-result', false);
      });
    }
  }
};